document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  const $priceDom = $('#sp_price1');
  const $cPriceDom = $('#sp_price2');
  const $offPriceDom = $('.font-off');
  const $numDom = $('#calcNumber');

  const productData = window.product || [];
  
// 跳转支付页面
      $(document).on('click', '.sp-btn-style', function () {
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })

  /** 获取当前选中的变量 */
  function getCur() {
    const opts = {
      option1: $('#sp-opt-group1 div.active').attr('data-val'),
      option2: $('#sp-opt-group2 div.active').attr('data-val'),
      option3: $('#sp-opt-group3 div.active').attr('data-val')
    };

    return productData.find(item => {
      return (!opts.option1 || item.option1 == opts.option1) &&
        (!opts.option2 || item.option2 == opts.option2) &&
        (!opts.option3 || item.option3 == opts.option3);
    });
  }

  /** 更新价格显示 */
  function changePrice() {
    const curVariant = getCur();
    if (!curVariant) return;

    const num = parseInt($numDom.val()) || 1;

    // 识别当前页面使用的小数点符号
    const currentText = $priceDom.text().trim();
    const decimalMatch = currentText.match(/([\.,])(\d+)(?!.*[\.,])/);

    const decimalSeparator = decimalMatch ? decimalMatch[1] : '.';
    const decimalLength = decimalMatch ? decimalMatch[2].length : 0;

    // 格式化输出
    const formatValue = (cents) => {
      let val = (cents * num / 100).toFixed(decimalLength);
      if (decimalSeparator === ',') {
        val = val.replace('.', ',');
      }
      return val;
    };

    const price = formatValue(curVariant.price);
    const compare = formatValue(curVariant.compare_at_price);

    // 计算折扣
    let offPercent = 0;
    if (curVariant.compare_at_price > curVariant.price) {
      offPercent = 100 - Math.ceil((curVariant.price / curVariant.compare_at_price) * 100);
    }

    const priceRegex = /\d+(?:[.,]\d+)*/;
    const offRegex = /(\d+)(?=(?:<[^>]+>|\s)*%)/g;

    const updateHTML = ($el, regex, value) => {
      if ($el && $el.length) {
        const text = $el[0].textContent.trim();
        const newHtml = text.replace(regex, value);
        if ($el.html() !== newHtml) {
          $el.html(newHtml);
        }
      }
    };

    updateHTML($priceDom, priceRegex, price);
    updateHTML($cPriceDom, priceRegex, compare);
    updateHTML($offPriceDom, offRegex, offPercent);
  }

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  new WOW().init();

  jQuery(".sp-scroll").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });

  new Swiper('.mySwiper', {
    slidesPerView: 'auto',
    spaceBetween: 35,
    loop: true, //循环滚动
    freeMode: true,
    speed: 6500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: true,
    },
    allowTouchMove: false,
  })

  new Swiper(".sp-part6 .sp-swiper1", {
    speed: 15000,
    autoplay: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: true,
  });

  new Swiper(".sp-part7 .sp-swiper1", {
    speed: 3500,
    autoplay: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: true,
  });

  function syncPart3SwiperFont(swiper) {
    var parent = swiper.el.parentElement;
    if (!parent) return;
    var font = parent.querySelector(".sp-font");
    if (!font) return;
    var idx = swiper.realIndex;
    Array.prototype.forEach.call(font.children, function (div, i) {
      div.classList.toggle("active", i === idx);
    });
  }

  document.querySelectorAll(".sp-swiper2").forEach(function (el) {
    var wrap = el.parentElement;
    if (!wrap) return;
    var nextBtn = wrap.querySelector(".sp-swiper-btn-next");
    var prevBtn = wrap.querySelector(".sp-swiper-btn-prev");
    var paginationEl = wrap.querySelector(".sp-pagination");
    var opts = {
      autoplay: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      slideShadows: true,
      slidesPerView: "auto",
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      on: {
        init: function (sw) {
          syncPart3SwiperFont(sw);
        },
        slideChange: function (sw) {
          syncPart3SwiperFont(sw);
        },
      },
    };
    if (paginationEl) {
      opts.pagination = { el: paginationEl, clickable: true };
    }
    new Swiper(el, opts);
  });

  new Swiper(".sp-swiper3", {
    autoplay: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    initialSlide: 1,
    pagination: {
      el: ".sp-pagination3",
      clickable: true,
    },
    navigation: {
      nextEl: ".sp-swiper-btn-next",
      prevEl: ".sp-swiper-btn-prev",
    },
  });

  new Swiper(".sp-swiper4", {
    speed: 9000,
    autoplay: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: true,
  });

  new Swiper(".sp-swiper-fade", {
    spaceBetween: 10,
    effect: "fade",
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  });

  new Swiper(".sp-swiper-fade1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
    on: {
      slideChange: function (e) {
        e.slides.find(".sp-text").each(function () {
          this.style.animation = "none";
        });
        const spText = e.slides.eq(e.activeIndex).find(".sp-text")[0];
        if (spText) {
          spText.style.animation = "none";

          spText.style.animation = `swiper-up-fade 0.5s ease forwards`;
        }
      },
    },
  });

  new Swiper(".sp-swiper0", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      if (document.body.clientWidth <= 1060) {
        let scale = document.body.clientWidth / 1080;
        $("#root").css("zoom", scale);
      } else {
        const scale = document.body.clientWidth / 1920;
        $("#root").css("zoom", scale);
      }

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
              } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
              }
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            if (dataSrc) {
              image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            }
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
        config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    let imgList = [
        'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/20260408-p1.png',
        'https://cdn.shopify.com/s/files/1/0567/2563/5150/files/2_d58f2e84-b6de-4333-834c-e5d2f38d53aa.png?v=1776137637',
        'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/20260408-p3.png',
        'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/20260408-p4.png',
    ];
    // for (let m = 1; m <= 4; m++) {
    //   imgList.push(`https://cdn.shopify.com/s/files/1/0781/3405/1121/files/20260408-p${m}.png`);
    // }
    
    // 预加载所有图片
    preloadImages(imgList);

    function updateMainImage() {
      let typeIndex = $("#sp-opt-group1 .sp-option.active").index();

      $(".sp-img-p").attr('src', imgList[typeIndex]);
    }

    $(".product-part .sp-option").click(function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      changePrice();
      updateMainImage();
    });

    // 初始化图片
    updateMainImage();

    // IOS字体多了间距的处理
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent);

    if (!isAndroid && !isIOS && !isPC) {
      $(".sp_system").css("letter-spacing", "-4px");
    }





    // 平整的左右滑动轮播
    carouselSwiper = new Swiper("#carousel .swiper", {
      grabCursor: true,
      centeredSlides: false,
      slidesPerView: 'auto',
      spaceBetween: 20,    // 卡片之间的间距
      loop: true,
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        reverseDirection: false,
      },
      freeMode: {
        enabled: true,
        momentum: false,
      },
      speed: 5000,
      on: {
        touchEnd: function () {
          // 触摸结束后，强制重启自动播放
          var swiper = this;
          setTimeout(function () {
            swiper.autoplay.stop();
            swiper.autoplay.start();
          }, 50);
        },
        slideChangeTransitionEnd: function () {
          // 滑动过渡结束后，确保自动播放继续
          var swiper = this;
          setTimeout(function () {
            if (!swiper.autoplay.running) {
              swiper.autoplay.stop();
              swiper.autoplay.start();
            }
          }, 50);
        }
      }
    });



    // 定期检查并重启自动播放（作为备用方案）
    setInterval(function () {
      if (carouselSwiper && !carouselSwiper.autoplay.running) {
        carouselSwiper.autoplay.start();
      }
    }, 1000);



  }

  mainRender();

  function initSpPart4SurfacePickers() {
    var SLOT_CLASSES = ["sp-img1", "sp-img2", "sp-img3", "sp-img4", "sp-img5"];
    var AUTO_MS = 3200;
    var boxes = document.querySelectorAll(".sp-part4 .sp-img-box");
    if (!boxes.length) return;

    var active = 0;
    var timer = null;

    function isPartVisible(part) {
      if (!part) return false;
      return part.offsetParent !== null;
    }

    function applyBox(box) {
      var imgs = box.querySelectorAll("img[data-surface-index]");
      var part = box.closest(".sp-part4");
      var textWrap = part ? part.querySelector(".sp-text") : null;
      var items = textWrap
        ? textWrap.querySelectorAll(".sp-item[data-surface-index]")
        : [];

      imgs.forEach(function (img) {
        var si = parseInt(img.getAttribute("data-surface-index"), 10);
        if (isNaN(si)) return;
        var offset = (si - active + 5) % 5;
        SLOT_CLASSES.forEach(function (c) {
          img.classList.remove(c);
        });
        img.classList.add(SLOT_CLASSES[offset]);
      });

      items.forEach(function (item) {
        var si = parseInt(item.getAttribute("data-surface-index"), 10);
        item.classList.toggle("active", si === active);
      });
    }

    function applyAll() {
      boxes.forEach(applyBox);
    }

    function bounceVisibleFronts() {
      boxes.forEach(function (box) {
        var part = box.closest(".sp-part4");
        if (!isPartVisible(part)) return;
        var front = box.querySelector(
          'img[data-surface-index="' + active + '"]'
        );
        if (!front) return;
        front.classList.remove("sp-surface-bounce");
        void front.offsetWidth;
        front.classList.add("sp-surface-bounce");
        window.setTimeout(function () {
          front.classList.remove("sp-surface-bounce");
        }, 700);
      });
    }

    function goTo(next, opts) {
      var animate = !opts || opts.animate !== false;
      active = ((next % 5) + 5) % 5;
      applyAll();
      if (animate) bounceVisibleFronts();
    }

    function startAuto() {
      if (timer) clearInterval(timer);
      timer = setInterval(function () {
        goTo(active + 1);
      }, AUTO_MS);
    }

    boxes.forEach(function (box) {
      var imgs = box.querySelectorAll("img[data-surface-index]");
      imgs.forEach(function (img) {
        img.style.cursor = "pointer";
        img.addEventListener("click", function () {
          var si = parseInt(img.getAttribute("data-surface-index"), 10);
          if (isNaN(si) || si === active) return;
          goTo(si);
          startAuto();
        });
      });
    });

    goTo(0, { animate: false });
    startAuto();
  }

  initSpPart4SurfacePickers();

  function initSpPart3PcGallery() {
    var root = document.querySelector(".sp-part3.sp-pc .sp-pc-part3-gallery");
    if (!root) return;

    var box = root.querySelector(".sp-img-box");
    var items = box ? box.querySelectorAll(".sp-img-item[data-slide-index]") : [];
    var font = root.querySelector(".sp-font");
    var labels = font
      ? font.querySelectorAll("div[data-slide-index]")
      : [];
    var prevBtn = root.querySelector(".sp-part3-pc-prev");
    var nextBtn = root.querySelector(".sp-part3-pc-next");
    var n = items.length;
    if (n < 2) return;

    var active = 0;
    var timer = null;
    var AUTO_MS = 4000;

    function applySlides(opts) {
      var animate = !opts || opts.animate !== false;
      items.forEach(function (item) {
        var si = parseInt(item.getAttribute("data-slide-index"), 10);
        if (isNaN(si)) return;
        var offset = (si - active + n) % n;
        item.style.order = String(offset);
        item.classList.remove("sp-pc-img-main", "sp-pc-img-thumb", "sp-pc-gallery-bounce");
        item.classList.add(offset === 0 ? "sp-pc-img-main" : "sp-pc-img-thumb");
      });

      labels.forEach(function (el) {
        var si = parseInt(el.getAttribute("data-slide-index"), 10);
        el.classList.toggle("active", si === active);
      });

      if (animate) {
        var mainEl = box.querySelector(".sp-img-item.sp-pc-img-main");
        if (mainEl) {
          mainEl.classList.remove("sp-pc-gallery-bounce");
          void mainEl.offsetWidth;
          mainEl.classList.add("sp-pc-gallery-bounce");
          window.setTimeout(function () {
            mainEl.classList.remove("sp-pc-gallery-bounce");
          }, 700);
        }
      }
    }

    function goTo(index, opts) {
      active = ((index % n) + n) % n;
      applySlides(opts);
    }

    function startAuto() {
      if (timer) clearInterval(timer);
      timer = setInterval(function () {
        goTo(active + 1);
      }, AUTO_MS);
    }

    items.forEach(function (item) {
      item.addEventListener("click", function () {
        var si = parseInt(item.getAttribute("data-slide-index"), 10);
        if (isNaN(si) || si === active) return;
        goTo(si);
        startAuto();
      });
    });

    function onPrev() {
      goTo(active - 1);
      startAuto();
    }

    function onNext() {
      goTo(active + 1);
      startAuto();
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", onPrev);
      prevBtn.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onPrev();
        }
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", onNext);
      nextBtn.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onNext();
        }
      });
    }

    goTo(0, { animate: false });
    startAuto();
  }

  initSpPart3PcGallery();

  // 找到所有跳转套餐的锚点链接 - 使用事件委托确保所有链接都能工作
  function handleShoppingLinkClick(event) {
    const link = event.target.closest('a[href="#shopping"]');
    if (!link) return;

    event.preventDefault();

    const targetElement = document.getElementById("shopping");
    if (targetElement) {
      const offsetTop = targetElement.offsetTop;
      let sptop = document.body.clientWidth <= 1080 ? 70 : 40;
      let zoomValue = parseFloat($("div#root").css("zoom")) || 1;
      const scrollTop = offsetTop * zoomValue - sptop * zoomValue;

      window.scrollTo({
        top: scrollTop,
        behavior: "smooth",
      });

      setTimeout(() => {
        if (window.pageYOffset === 0 || Math.abs(window.pageYOffset - scrollTop) > 100) {
          $('html, body').animate({
            scrollTop: scrollTop
          }, 800);
        }
      }, 100);
    }
  }

  // 使用事件委托在document上监听所有点击
  document.addEventListener('click', handleShoppingLinkClick);

  let sp_price1 = 37.99;
  let sp_price2 = 59.98;

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }
  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    changePrice();
    // $("#sp_price1").html('€' + calcTotal(sp_price1, input.value));
    // $("#sp_price2").html('€' + calcTotal(sp_price2, input.value));
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice();
    // $("#sp_price1").html('€' + calcTotal(sp_price1, input.value));
    // $("#sp_price2").html('€' + calcTotal(sp_price2, input.value));
  });

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span, div");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span/div 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade2 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

  // 菜单
  $(".sp-menu-btn").click(function (e) {
    $(".sp-menu-mask").show();
  });

  $(".sp-menu-mask").click(function (e) {
    $(".sp-menu-mask").hide();
  });

  function getZoomValue() {
    let zoom = $("div#root").css("zoom");
    return parseFloat(zoom) || 1;
  }

  function handleScroll() {
    // let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    // let zoomValue = getZoomValue();
    // let headerHeight = $(".header:visible").height() * zoomValue;

    // if (scrollTop > headerHeight) {
    //   $(".sp-pc .sp-header-top").addClass("sp-fixed");
    // } else {
    //   $(".sp-pc .sp-header-top").removeClass("sp-fixed");
    // }
  }

  // 初始检查
  handleScroll();

  // 监听多种滚动事件
  window.addEventListener('scroll', handleScroll, true);
  document.addEventListener('scroll', handleScroll, true);

  $(function () {
    // 判断是否为移动端
    function isMobile() {
      return document.body.clientWidth <= 1060;
    }

    // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      if (isMobile()) {
        $(".sp-mobile .sp-cart .num").show();
        $(".sp-mobile .sp-cart").addClass("on");
        setTimeout(function () {
          $(".sp-mobile .sp-cart").removeClass("on");
        }, 500);
      } else {
        $(".sp-pc .sp-header-top .sp-cart .num").show();
        $(".sp-pc .sp-header-top .sp-cart").addClass("on");
        setTimeout(function () {
          $(".sp-pc .sp-header-top .sp-cart").removeClass("on");
        }, 500);
      }
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
    });

    let initNum = 0;

    $(".product-part .cart-btn").click(function () {
      let spNum = $("#calcNumber")[0].value;
    //   initNum += Number(spNum);
    var data = {
        id: getCur().id,
        quantity: spNum,
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            // $("#cardNum").html(result.item_count);
            console.log("result",result.item_count)
            initNum=result.item_count
            
            // 更新购物车数量
            if (isMobile()) {
              $(".sp-mobile .cardNum").each(function () {
                $(this).html(initNum);
              });
            } else {
              $(".sp-pc .cardNum").each(function () {
                $(this).html(initNum);
              });
            }
            $(".cardNum").removeClass("sp-gray");

          });
        },
        dataType: "json",
      });

      var imgs = $(".sp-img-p.active");

      imgs.each(function () {
        var $img = $(this);
        var flyer = $img[0].cloneNode(true);
        flyer.classList.add("sp_clone");

        $(".product-part").append(flyer);
        $(flyer).css({
          width: $img[0].width,
          height: $img[0].height,
          background: "#e7e9ef",
          position: "fixed",
          top: $img[0].offsetTop,
          left: $img.offset().left,
          "z-index": 99,
        });

        let finish, targetTop, targetLeft;

        if (isMobile()) {
          // 移动端：飞向底部固定按钮中的购物车
          finish = $(".sp-btn-style2.sp-mobile .sp-cart");
          if (finish.length > 0) {
            targetTop = $(".sp-btn-style2")[0].offsetTop;
            targetLeft = $(".sp-btn-style2 .sp-cart")[0].offsetLeft + finish.width() / 2;
          } else {
            targetTop = 0;
            targetLeft = 0;
          }
        } else {
          // PC端：飞向header中的购物车
          finish = $(".sp-pc .sp-cart");
          if (finish.length > 0) {
            targetTop = finish[0].offsetTop + 20;
            targetLeft = finish[0].offsetLeft;
          } else {
            targetTop = 0;
            targetLeft = 0;
          }
        }

        $(flyer).animate(
          {
            top: targetTop,
            left: targetLeft,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      });
    });
  });

  // 问答
  $(".q-row").click(function () {
    $(this).parent().toggleClass("sp-show");
  });

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName("sp-fade-box");
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;
              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually2);
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`;
              span.style.animationDelay = `${index * 0.3 + 1}s`;
            });

            observerAni.unobserve(gradually3);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually3);
  }
});
